export default __webpack_public_path__ + "static/media/end.ab9f03e9.svg";